import { createContext } from "react";
import type {
  TransactionRequest,
  TransactionResponse,
  WalletAccount,
  WalletAdapterStatus,
} from "../utils/types";

export interface WalletContextType {
  status: WalletAdapterStatus;
  selectedAccount: WalletAccount | null;
  connect: () => Promise<void>;
  disconnect: () => Promise<void>;
  sendTransaction: (tx: TransactionRequest) => Promise<TransactionResponse>;
  switchChain?: (chainId: number) => Promise<boolean>; // Optional for external wallets
}

export const WalletContext = createContext<WalletContextType | undefined>(undefined);
